module.exports = __webpack_public_path__ + "static/carte_1200px_mobile-01a23b3d998fe4129b28764bd7f63ca3.svg";